// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../graphql/api/index';

export const ComponentTitleTextFragmentDoc = `
    fragment componentTitleText on ComponentTitleText {
  __typename
  text
}
    `;